window.mahasamund_encrypt = async (publicKey, text) => {
	const der = Uint8Array.from(atob(publicKey), (c) => c.charCodeAt(0));
	const key = await crypto.subtle.importKey("spki", der, { name: "RSA-OAEP", hash: "SHA-256" }, false, [
		"encrypt",
	]);
	const data = await crypto.subtle.encrypt({ name: "RSA-OAEP" }, key, new TextEncoder().encode(text));
	return btoa(String.fromCharCode(...new Uint8Array(data)));
};
